export class AutoDebitExtractionSearchCriteria {

    // constructor() {
    //     this.month = null;
    //     this.segmentDetails = '';        
    // }

    month!: Date;
    segmentDetails!: string;   
}